module.exports = __webpack_public_path__ + "static/media/fuel.1765a34d.svg";